import { Bar } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  useTheme,
  colors,
} from '@mui/material';
import LoadingProgress from '../LoadingProgress';

function SalesReport(props) {
  const theme = useTheme();
  const reportState = useSelector((state) => state.reportsReducer);
  const { orderSalesReport, loadingOrderSales } = reportState;

  const data = orderSalesReport ? {
    datasets: [
      {
        backgroundColor: colors.indigo[500],
        barPercentage: 0.5,
        barThickness: 12,
        borderRadius: 4,
        categoryPercentage: 0.5,
        data: orderSalesReport.currentYear.map((item) => item.sales),
        label: orderSalesReport.currentYearTitle,
        maxBarThickness: 14,
      },
      {
        backgroundColor: colors.pink[200],
        barPercentage: 0.5,
        barThickness: 12,
        borderRadius: 4,
        categoryPercentage: 0.5,
        data: orderSalesReport.previousYear.map((item) => item.sales),
        label: orderSalesReport.previousYearTitle,
        maxBarThickness: 14,
      },
    ],
    labels: orderSalesReport.currentYear.map((item) => `${item.monthText}`),
  } : { datasets: [] };

  const options = {
    animation: false,
    cornerRadius: 20,
    layout: { padding: 0 },
    legend: { display: false },
    maintainAspectRatio: false,
    responsive: true,
    tooltips: {
      backgroundColor: theme.palette.background.paper,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: 'index',
      titleFontColor: theme.palette.text.primary,
    },
  };

  return (
    <Card>
      <CardHeader
        title="Sales"
      />
      <Divider />
      <CardContent>
        <Box
          sx={{
            height: 300,
            position: 'relative',
          }}
        >
          {loadingOrderSales ? <LoadingProgress /> : (
            <Bar
              data={data}
              options={options}
            />
          )}

        </Box>
      </CardContent>
      {/* <Divider /> */}
      {/* <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          p: 2,
        }}
      >
        <Button
          color="primary"
          endIcon={<ArrowRight />}
          size="small"
          variant="text"
        >
          Overview
        </Button>
      </Box> */}
    </Card>
  );
}

export default SalesReport;
